import { render, staticRenderFns } from "./tableInfo.vue?vue&type=template&id=e471f952&scoped=true"
import script from "./tableInfo.vue?vue&type=script&lang=js"
export * from "./tableInfo.vue?vue&type=script&lang=js"
import style0 from "./tableInfo.vue?vue&type=style&index=0&id=e471f952&prod&lang=scss"
import style1 from "./tableInfo.vue?vue&type=style&index=1&id=e471f952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e471f952",
  null
  
)

export default component.exports